<template>
<div id="cart-form" v-if="cart.delivery != null">

  <h3>Doručení</h3>

  <!-- Country select -->
  <country-select :contact="cart.delivery.shipping" @updated="countrySelected" />

  <!-- <div v-if="showForm && googleLoaded"> -->
  <div v-if="showForm">

    <!-- Delivery module selection -->
    <div id="deliver-module">

      <!-- Shipping way selection -->
      <shipping :cart="cart" :shopData="shopData" @updated="shippingSelected" />

    </div>

    <!-- Delivery details -->
    <div id="delivery-details" v-if="(cart.delivery.code != '') && (cart.delivery.code != null) && (cart.delivery.slot != null && cart.delivery.slot != -1)">

      <div v-if="cart.delivery.code.indexOf('BRANCH') != 0">
        <h3>Doručovací údaje</h3>
        <div class='pfm-checkbox' :class="{'checked': this.cart.delivery.billing.shippingIsSame}">
          <div class='box-label-wrap'>
            <div class='box' @click="shippingSameChanged">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-tick'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
            </div>
            <!-- <label>Stejné fakturační údaje</label> -->
            <label>Nakupuji pro sebe</label>
          </div>
        </div>

        <div v-if="cart.delivery.billing">
          <div class='pfm-checkbox' :class="{'checked': cart.delivery.billing.forCompany}">
            <div class='box-label-wrap'>
              <div class='box' @click="cart.delivery.billing.forCompany = !cart.delivery.billing.forCompany">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-tick'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
              </div>
              <label>Nakupuji / posílám na firmu</label>
            </div>
          </div>
        </div>

        <div v-if="!this.cart.delivery.billing.shippingIsSame">
          <!-- Shipping address -->
          <contact-shipping :data="cart.delivery.shipping" :name="'shipping'" :isForCompany="cart.delivery.billing.forCompany" :same="this.cart.delivery.billing.shippingIsSame" @updated="formUpdated" />

          <!-- Additional fields depending on the delivery method -->
          <contact-plus-info :shopData="shopData" :delivery="cart.delivery" @updated="formUpdated" />
        </div>

      </div>

      <!-- Billing address -->
      <div id='invoicing-details'>
        <!-- <h3 v-if="!this.cart.delivery.billing.shippingIsSame">Fakturační údaje</h3> -->
        <h3 v-if="!this.cart.delivery.billing.shippingIsSame">Moje údaje</h3>

        <div class='pfm-checkbox' :class="{'checked': cart.delivery.billing.forCompany}" v-if="cart.delivery.code.indexOf('BRANCH') == 0">
          <div class='box-label-wrap' @click="cart.delivery.billing.forCompany = !cart.delivery.billing.forCompany">
            <div class='box'>
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-tick'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
            </div>
            <input type="checkbox" id="forCompany" v-model="cart.delivery.billing.forCompany" @change="formUpdated" />
            <label for="forCompany" @click.stop>Nakupuji / posílám na firmu</label>
          </div>
        </div>

        <!-- <contact-billing v-if="!this.cart.delivery.billing.shippingIsSame || cart.delivery.code.indexOf('BRANCH') == 0" -->
        <contact-billing :data="cart.delivery.billing" :name="'billing'" :isForCompany="cart.delivery.billing.forCompany" :same="this.cart.delivery.billing.shippingIsSame" :showCountry="true" @updated="formUpdated" />

        <!-- Additional fields depending on the delivery method -->
        <contact-plus-info v-if="this.cart.delivery.billing.shippingIsSame" :shopData="shopData" :delivery="cart.delivery" @updated="formUpdated" />

      </div>
    </div>

    <!-- Payment selection -->
    <payment v-if="(paymentOptions.length > 0) && deliverySlotNotNeededOrValid" :cart="cart" :paymentOptions="paymentOptions" @paymentError="paymentError" @updated="formUpdatedCalculate" />

    <!-- Note -->
    <div id="final-step" v-if="cart.payment != null && cart.payment.methodCode != null && cart.payment.methodCode != '' && deliverySlotNotNeededOrValid">
      <!-- <h3>Máte něco na srdci?</h3> -->
      <!-- <textarea name="note" id="client-note" @change="formUpdated" v-model="cart.note"></textarea> -->
      <!-- <div class="cart-note" @change="noteUpdated" @keydown="noteUpdated" contenteditable="true" v-once>{{cart.note}}&nbsp;</div> -->
      <text-field :data="cart" name="note" label='Ještě něco na srdci?' kind='input' type='note' placeholder='Kámen!' helpText='Budeme se snažit splnit modré z nebe! Ale taky jsme jen lidi, žejo 😜' @updated="noteUpdated"></text-field>



      <!-- order/payment button -->
      <div id='process-order-button-wrap'>
        <a href="javascript:" class="pfm-button order-button" :class="[cart.processingState, {'shake': cart.processingState == 'failed'}, {'icononly': ['working', 'success'].includes(cart.processingState)}]" id="processPayment" @click="processPayment"
          v-if="isCardOnline">
          <div v-if="cart.processingState == 'init'">
            <span>Zaplatit <span class='lower'>{{cart.total|formatPrice}}</span></span>
          </div>
          <div v-if="['working', 'pendingPayment'].includes(cart.processingState)">
            <div class='animation-wrap loading'>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
            </div>
          </div>
          <div v-if="cart.processingState == 'failed'">
            <span>něco je špatně :(</span>
          </div>
          <div v-if="cart.processingState == 'success'">
            <div class='icon-wrap done'>
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
            </div>
          </div>
        </a>
        <a href="javascript:" class="pfm-button pay-button" id="createOrder" @click="createOrder" v-if="!isCardOnline">
          <div v-if="cart.processingState == 'init'">
            <span>Objednat za <span class='lower'>{{cart.total|formatPrice}}</span></span>
          </div>
          <div v-if="['working', 'pendingPayment'].includes(cart.processingState)">
            <div class='animation-wrap loading'>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
            </div>
          </div>
          <div v-if="cart.processingState == 'failed'">
            <span>něco je špatně :(</span>
          </div>
          <div v-if="cart.processingState == 'success'">
            <div class='icon-wrap done'>
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div v-else class='whitespace'></div>

  </div>

</div>
</template>

<script>
import Cart from '@/cart'

import Notification from '@/notification';
import Utils from '@/utils';
import Axios from 'axios'

import Shipping from './Shipping';
import ContactShipping from './ContactShipping';
import ContactBilling from './ContactBilling';
import ContactPlusInfo from './ContactPlusInfo';
import Payment from './Payment';
import CountrySelect from './CountrySelect';
import TextField from '@/components/common/TextField'
import GoogleMapsApiLoader from '@/service/GoogleMapsApiLoader'

import Validator from '@/service/Validator'

export default {
  props: ['cart', 'shopData'],
  components: {
    Shipping,
    ContactShipping,
    ContactBilling,
    ContactPlusInfo,
    Payment,
    CountrySelect,
    TextField
  },
  data() {
    return {
      lang: Cart.lang,
      paymentOptions: [],
      showForm: false,
      googleLoaded: false,
      delivery: this.cart.delivery,
      deliverySlotNotNeededOrValid: this.cart.delivery ? (this.cart.delivery.slot != null && this.cart.delivery.slot != undefined && this.cart.delivery.slot != -1) : true,
      // processingState: this.cart.processingState, // init, working, failed, success
      // cartProcessingState: this.cart.processingState
    }
  },
  computed: {
    isCardOnline() {
      return ['STRIPE', 'PAYU', 'PAYU-POPUP'].includes(this.cart.payment.methodCode)
    }
  },
  watch: {
    delivery: {
      deep: true,
      handler() {
        console.log('Slot not needed or valid', this.deliverySlotNotNeededOrValid, this.cart.delivery.slot, this.cart.delivery.slot != null && this.cart.delivery.slot != undefined && this.cart.delivery.slot != -1)
        this.deliverySlotNotNeededOrValid = this.cart.delivery.slot != null && this.cart.delivery.slot != undefined && this.cart.delivery.slot != -1
        if (this.cart.delivery.slot) {
          console.log('Should recalculate the total price')
        }
      }
    },
    'delivery.code': {
      handler() {
        // because we are yet unable to validate already filled restricted address (check if it is withing specified square), we have to wipe it, if customer switches from branch to any other delivery method. If we wouldn't erase it, customer could input any address while on branch delivery, switch to courier and we'd have to deliver outside of restricted area.
        console.log('restrictAddress CartForm: delivery.code changed to:', this.delivery.code)
        if (!this.delivery.code.match(/BRANCH/)) {
          if (this.delivery.shipping.address) {
            console.log('restrictAddress resetting shipping address')
            this.delivery.shipping.address = {}
          } else {
            console.log('restrictAddress resetting billing address')
            this.delivery.billing.address = {}
          }
        }
      }
    }
    // processingState() {
    //   console.log('cartProcessingState changed', this.cart.processingState)
    //   if (this.cart.processingState == 'success') {
    //     this.processingState = this.cart.processingState
    //   }
    // }
  },
  created() {
    console.log('CartForm::created', this.cart, this.shopData, this.deliverySlotNotNeededOrValid)

    if (this.cart.payment === undefined) {
      Vue.set(this.cart, 'payment', {})
    }
    if (this.cart.payment && this.cart.payment.methodCode === undefined) {
      Vue.set(this.cart.payment, 'methodCode', '')
    }
    if (this.cart.delivery && this.cart.delivery.billing && this.cart.delivery.billing.shippingIsSame === undefined) {
      Vue.set(this.cart.delivery.billing, 'shippingIsSame', true)
    }
    if (this.cart.delivery && this.cart.delivery.shipping != undefined) {
      this.showForm = this.cart.delivery.shipping.country && this.cart.delivery.shipping.country != ''
    }

    if (['working', 'pendingPayment'].includes(this.cart.processingState)) {
      Utils.scrollTo({
        targetElementId: 'final-step'
      })
    } else {
      Utils.scrollTo({
        targetElementId: 'cart-form'
      })
    }
  },
  async mounted() {
    // if (Cart.google == null) {
    //   const googleMapApi = await GoogleMapsApiLoader({
    //     libraries: ['places'],
    //     apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    //     language: 'cs',
    //     sessiontoken: this.cart.cartId
    //   })
    //   Cart.google = googleMapApi
    //   console.log('Google loaded')
    //   this.googleLoaded = true
    // } else {
    //   this.googleLoaded = true
    // }
  },
  methods: {
    shippingSameChanged() {
      this.cart.delivery.billing.shippingIsSame = (this.cart.delivery.billing.shippingIsSame == undefined) ? true : !this.cart.delivery.billing.shippingIsSame
      console.log('Shipping same changed', this.cart.delivery.billing.shippingIsSame)
      this.formUpdated()
    },
    validate() {
      console.log('Validating cart form')
      // this.$validator.localize('cs');
      // this.$emit('validateContact', this.validationCallBack);
      return Validator.validate()
        .then(result => {
          if (!result) {
            console.log('Invalid form values')
            // Notification.add('err', 'Prosím, opravte své údaje', 15)
            this.processingStateFailed()
            return false
          } else {
            let isThereError = false
            Object.keys(this.$store.state.paymentValidations.errors).forEach(k => {
              if (this.$store.state.paymentValidations.errors[k] != '') {
                isThereError = true
              }
            })
            this.$store.commit({
              type: 'paymentValidations/setValidationResult',
              value: isThereError
            })
            if (isThereError) {
              console.log('Payment form has some errors')
              Cart.submitFailed({response: {data: {code: 'PAYMENT_FORM_ERROR'}}})
              return false
            }
            console.log('Cart form is valid', result)
            // Lets check the formal cart validity.
            return Cart.isCartValid()
          }
        })

    },
    processingStateFailed() {
      this.cart.processingState = 'failed'
      Cart.globals.overlayActive = false
      // reset after N s
      setTimeout(() => {
        this.cart.processingState = 'init'
      }, 3000)
    },
    validationCallBack(result) {
      // console.log('validation result', result)
    },
    getPrice(shipping) {
      if (shipping.price != null) {
        // TODO Find price for given goods dimensions
        return shipping.price[0].brutto
      } else {
        return '0'
      }
    },
    countrySelected(country) {
      console.log('Country selected', country)
      this.formUpdated()
    },
    shippingSelected() {
      console.log('Shipping module', this.cart.delivery.code, this.shopData, this.cart.delivery.slot)
      if (this.cart.delivery.code != null && this.cart.delivery.code != -1 && this.cart.delivery.code != '') {
        this.paymentOptions.splice(0)
        let deliveryCode = this.cart.delivery.code
        if (deliveryCode.indexOf('-') > -1) {
          deliveryCode = deliveryCode.split('-')[0]
        }
        // console.log('Searching delivery code', deliveryCode)
        // Find proper delivery module
        let shipping
        for (var i = 0; i < this.shopData.shippings.length; i++) {
          // console.log('Searching delivery', this.cart.delivery.code, this.shopData.shippings[i].code)
          if (deliveryCode == this.shopData.shippings[i].code) {
            shipping = this.shopData.shippings[i]
            break
          }
        }
        // console.log('Getting payment options', shipping, this.shopData.payments.methods)
        for (var i = 0; i < this.shopData.payments.methods.length; i++) {
          // console.log(`Is possible ${this.shopData.payments.methods[i].method}`)
          if (shipping.payments.indexOf(this.shopData.payments.methods[i].code) > -1) {
            this.paymentOptions.push(this.shopData.payments.methods[i])
          }
        }

        // Set the price - TODO For now, get the first price defined, but the delivery should consider dimensions of the product.
        this.cart.delivery.price = (shipping.price != null) ? shipping.price[0] : null;
        if (this.cart.delivery.slot && this.cart.delivery.slot.price) {
          this.cart.delivery.price = this.cart.delivery.slot.price
        }
        console.log('Payment options', this.paymentOptions, this.cart.delivery.price)
      }
      this.formUpdatedCalculate()
    },
    noteUpdated(text) {
      // console.log('noteUpdated', text)
      // THIS WAS BROKEN, SO IT WAS COMMENTED OUT
      // Don't save the value, if no actual character was typed in.
      // if ([16, 17, 18, 19, 20, 27, 35, 36, 37, 38, 39, 40, 91, 93, 224].includes(text.keyCode) || (text.ctrlKey && ![86, 88, 90].includes(text.keyCode)) || text.keyCode === undefined) {
      //   console.log('skipping')
      //   return;
      // }
      var that = this

      // TODO: delay was broken
      Utils.onPause('cart-note-edited', () => {
        that.cart.note = text //.target.innerText
        console.log('emitting cart note')
        that.$emit('updated', {
          calculate: false,
          hide: false
        });
      }, 250)

    },
    formUpdated() {
      this.showForm = this.cart.delivery.shipping.country && this.cart.delivery.shipping.country != ''
      this.$emit('updated', {
        calculate: false
      });
    },
    formUpdatedCalculate() {
      // console.log('Update cart', JSON.stringify(this.cart.delivery))
      this.$emit('updated', {
        calculate: true
      });
    },
    // These method are for Payment Brain tree component
    paymentError(message) {
      console.error(message);
      this.processingStateFailed()
      // Notification.add('err', message, 15)
    },
    btHFPayload(payload) {
      console.log(payload);
      // do something with the token payload
    },

    // Creates the order
    createOrder() {
      if (this.cart.processingState == 'init') {
        console.log('CartForm.vue:createOrder()')
        this.validate() //
          .then(result => {
            if (result) {
              // This creates the order for further payment method.
              // Such as by cash at the shop, or bank wire.
              this.cart.processingState = 'working'
              Cart.placeOrder()
            }
          })
      } else {
        console.warn('createOrder: already processing')
      }
    },
    // Submits the payment and then creates the order
    processPayment() {
      if (this.cart.processingState == 'init') {
        console.log('CartForm.vue:processPayment()')
        this.validate()
          .then(result => {
            if (result) {
              // First pay, and then send the order to server.... or the other way
              // The payment is performed in Brain Tree Hosted / Dropin component.
              this.cart.processingState = 'working'
              Cart.globals.overlayActive = true
              Cart.globals.overlayColor = 'light'
              this.$emit('submitPayment');
            }
          })
      } else {
        console.warn('processPayment(): already processing')
      }
    }
  }
}
</script>

<style lang='less'>
@import '../../variables.less';

#cart-form {

    h3 {
        padding-top: 20px;
    }

    #deliver-module {
        padding-top: 10px;

    }

    #delivery-details {
        padding-top: 30px;

        .pfm-cart-input-field {
            margin: 8px 0;
        }

    }

    #invoicing-details {
        // padding-top: 30px;
    }

    #final-step {
        padding-top: 30px;

        #process-order-button-wrap {
            padding: 30px 0;

            .pfm-button {
              z-index: 9999999;
              position: relative;

                &.order-button,
                &.pay-button {

                    span.lower {
                        text-transform: none;
                    }
                }

                &.order-button {}

                &.pay-button {}
            }
        }
    }

    .whitespace {
        height: 20px;
    }
}
</style>
